var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rdy)?_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.task.taskDesc)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }